import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { NewsletterFormComponent } from '../../../newsletter/newsletter-form.component';
import { CMS_COMPONENT_NEWSLETTER_CONFIG } from './cms-component-newsletter.config';
import { NCmsComponentNewsletter } from './cms-component-newsletter.interface';

@Component({
    selector: 'cms-component-newsletter',
    templateUrl: './cms-component-newsletter.component.html',
    standalone: true,
    imports: [NewsletterFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentNewsletterComponent>(CMS_COMPONENT_NEWSLETTER_CONFIG)
export class CmsComponentNewsletterComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentNewsletter.IData;
}
